<template>
    <div style="background:#78143a">
        <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#fff">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l121ce_ctrl_container l121ce">

            <!-- board -->
            <div class="l121ce_board">
                <div class="board-item" v-for="(it, key) in testDays">
                <template v-if="datas.board[key]">
                    <span>登录账号：{{ datas.board[key].login }}</span>
                    <span  v-if="key!=0">{{ key==1 ? '次': key + 1 }}日留存：{{ datas.board[key].liucun }}</span>
                </template>
                </div>
                <div class="tips">
                    <p v-for="t in datas.board.tips">{{ t }}</p>
                </div>
            </div>
        
            <!-- 表格 -->
            <div class="l121ce_ctrl_tables" v-for="(it,index) in datas.results" :key="`table${index}`" >
                <div class="table_title">
                    <h2>{{ it.title }}</h2>
                </div>
                <ul class="nav-group" v-if="it.groupNav">
                    <li>分组选择：</li>
                    <li :class="{active: it.active == iit.id}" v-for="iit in it.groupNav" @click="select(index, iit.id)">
                    <a href="javascript:;">{{ iit.title }}</a>
                    </li>
                </ul>
                <DataTable :fields="it.thead" :datas="it.data" class="l121ce_ctrl_table" :paging="false"/>
                <div class="tips">
                    <p v-for="t in it.tips">{{ t }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l121ce',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
    },
    mounted(){
        this.initData()
    },
    data() {
        return {
            testDays:8,
            datas: {
                board: [],
                results: [],
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        initData() {
            this.loading = true
            let q_board = this.$service.query(this.queryId, {type:'board'});
            let q_subtype = this.$service.query(this.queryId, {type:'subtypelist'});
            let q_task = this.$service.query(this.queryId, {type:'task'});
            
            Promise.all([q_board, q_subtype, q_task]).then((datas) => {
                this.datas.board = datas[0]
                this.datas.results = datas[1]
                datas[1].forEach((result, idx)=>{
                    result.thead = [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}, {title:'第8日', children: [{id:'lc_7', title:'留存'}, {id:'online_7', title:'在线'}]}]
                    result.tips = ['登录、留存：首日激活账号后续的登录、留存情况；', '平均在线时长：截止到数据获取时该组别玩家平均在线时长（分钟）']
                    this.select(idx, result.groupNav[0].id)
                })
                this.datas.results.push({
                    title: '玩法参与完成情况',
                    thead: [{id:'title', title:'玩法'}, {title:'首日', children: [{id:'play_0', title:'参与率'}, {id:'finish_0', title:'完成率'}]}, {title:'次日', children: [{id:'play_1', title:'参与率'}, {id:'finish_1', title:'完成率'}]}, {title:'第3日', children: [{id:'play_2', title:'参与率'}, {id:'finish_2', title:'完成率'}]}, {title:'第4日', children: [{id:'play_3', title:'参与率'}, {id:'finish_3', title:'完成率'}]}, {title:'第5日', children: [{id:'play_4', title:'参与率'}, {id:'finish_4', title:'完成率'}]}, {title:'第6日', children: [{id:'play_5', title:'参与率'}, {id:'finish_5', title:'完成率'}]}, {title:'第7日', children: [{id:'play_6', title:'参与率'}, {id:'finish_6', title:'完成率'}]}, {title:'第8日', children: [{id:'play_7', title:'参与率'}, {id:'finish_7', title:'完成率'}]}],
                    data:datas[2],
                    tips: ['参与率：参与角色ID数/可参加等级及以上登录角色ID数；', '完成率：完成角色ID数/参与角色ID数', '（如玩法有多个任务或多个副本，角色通过一个任务或副本即为完成，次数完成率详见玩法参与率完成率）'],
                })
                this.loading = false
            }).catch((errors)=>{
                console.log(errors)
                this.loading = false
            })
        },
        
        select(index, id) {
            if (id === this.datas.results[index].active) {
                return
            }
            this.datas.results[index].active = id
             this.datas.results[index].data = []
            this.$service.query(this.queryId, {flag:index, subtype:id}).then((data)=>{
                this.datas.results[index].data = data
            })
        },
    }
}
</script>
<style lang="less">
.l121ce_ctrl_table {
    .ant-table {
        background:#374377;
        color:#fff;
    }
    .ant-table-thead {
        border:none;
    }
    .ant-table-placeholder {
        background: none;
        color:rgba(255,255,255,0.6)
    }
    .ant-table-thead > tr > th {
        background: #861239;
        color:#fff;
    }
    .ant-table-tbody > tr > td {
        border-color:#7982ad;
    }
    .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
        color:#fff;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        padding:5px 0;
    }
    .ant-table-tbody > tr:nth-child(2n) td{
        background:#0b143e;
    }
    .ant-table-tbody > tr:hover td{
        background:#861239;
    }
    .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 5px 0px;
    }
}
</style>
<style lang="less" scoped>
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.l121ce_ctrl_container {
    min-height: 700px;
    .l121ce_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .l121ce_ctrl_title {
        height:100px;
        width:100%;
        margin:0 0 40px 0;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .l121ce_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: @width;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #fff; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:40%;
                    border-bottom: 1px solid #fff;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:40%;
                    border-bottom: 1px solid #fff;
                }
            }
        }
        .l121ce_ctrl_table {
            .ant-table {
                background:#374377;
                color:#fff;
            }
            .ant-table-thead {
                border:none;
            }
            .ant-table-placeholder {
                background: none;
                color:rgba(255,255,255,0.6)
            }
            .ant-table-thead > tr > th {
                background: #861239;
                color:#fff;
            }
            .ant-table-tbody > tr > td {
                border-color:#7982ad;
            }
            .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
                color:#fff;
            }
            .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-tbody > tr:nth-child(2n) td{
                background:#0b143e;
            }
            .ant-table-tbody > tr:hover td{
                background:#861239;
            }
            .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
                padding: 5px 0px;
            }
        }
        .l121ce_small_table {
            width:90%;
            margin:0 auto;
            font-size:13px;
            text-align: center;
            tr > th {
                background: #861239;
                color:#fff;
                padding:5px 5px;
            }
            tr > td {
                background:#374377;
                color:#fff;
                border-color:#7982ad;
                padding:5px 5px;
            }
            tr:nth-child(2n) td{
                background:#0b143e;
            }
        }
        .tips { color: #8c9ac1; margin-top: 10px; text-align:center; p{margin:0;}}

        @mainColor: #8c9ac1;
        .nav-group {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
            color: @mainColor;
            li {
                &:after {
                content: "|";
                color: #bbb;
                }
                &:first-child:after,
                &:last-child:after {
                content: "";
                }
            }
            a {
                display: inline-block;
                vertical-align: middle;
                padding: 5px 15px;
                margin-left: 10px;
                margin-right: 10px;
                white-space: nowrap;
                color: @mainColor;
            }
            .active a {
                color: #fff;
                background: #861239;
                font-weight: 600;
            }
        }
    }

    &.l121ce {
        background: #151a40 url('../../../assets/img/ctrl/l12/bg.jpg') no-repeat;
        overflow:hidden;
    }

        
    .l121ce_board {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        max-width: 1440px;
        margin: 200px auto 120px;
        padding: 70px 25px 30px;
        border: 10px solid #505698;
        background: rgba(32, 36, 84, 0.78);
        box-shadow: 0 0 30px #0b0c2f;
        &:before {
            content: "";
            position: absolute;
            width: 1200px;
            height: 135px;
            left: 0;
            margin-left: 20px;
            top: -80px;
            background: url(../../../assets/img/ctrl/l12/title.png) no-repeat;
            z-index: 1;
        }

        .board-item {
            width:150px;
            height:150px;
            margin-bottom: 20px;
            padding:80px 15px 0 15px;
            background:rgba(200,200,200,0.4);
            color: #777;
            position: relative;
            display: inline-block;
            &:before {
                content: "";
                top: 0;
                left:0;
                z-index: 1;
                position: absolute;
                width: 100%;
                height: 60px;
                background: #eee url(../../../assets/img/ctrl/l12/1ce_days.png) top center no-repeat;
            }
        }
        .board-item span{line-height:24px; color:#fff; display:block}
        .tips { color: #8c9ac1; margin-top: 10px; text-align:center; 
            p{margin:0}
        }
    }
}
</style>